{
  "it": {
    "message": {
      "actions": {
        "delete_message": "Elimina messaggio",
        "move_selected": "Sposta messaggi selezionati",
        "send": "Invia"
      },
      "labels": {
        "already_replied": "ha già una risposta",
        "cannot_delete_message": "Questo messaggio è già stato letto dal cliente e pertanto non può essere eliminato.",
        "changes_not_saved": "Ci sono modifiche non salvate. È sicuro di voler continuare?\np.s.: Può aprire una nuova scheda per navigare su altre pagine contemporaneamente.",
        "delete_message": "Questo eliminerà il messaggio per tutti. Tenga presente che potrebbe già essere stata inviata una notifica via email, a seconda delle impostazioni del destinatario.",
        "delete_message_abort": "Il messaggio non può essere eliminato",
        "move_customer_notification": "Il cliente verrà notificato quando il messaggio viene trasferito a un'altra conversazione",
        "move_to": "Sposta messaggio in...",
        "moved_here": "qui dalla conversazione",
        "moved_message": "ha spostato questo messaggio",
        "moving_message": "Spostamento messaggio",
        "notSeenYet": "Non ancora visto",
        "seen_by": "Visto da {participants}",
        "to": "a",
        "you": "Lei"
      },
      "validation": {
        "message_required": "Il messaggio è obbligatorio"
      }
    }
  }
}
